<h2 class="text-muted pb-2 border-bottom mt-4">Hightlights</h2>

<div class="row">
  <div class="col-md-6">
    <div class="card bg-success">
      <div class="card-body">
        <p class="card-text">
Goal-driven, practical and focused professional with diverse knowledge in various fields including web application development, database management and administration, telecommunications and electronics.        </p>
      </div>
    </div>
    

    <div class="card bg-danger mt-3">
      <div class="card-body">
        <p class="card-text">
          Energetic, competitive, self-driven achiever capable of working in a fast-paced environment with minimum supervision.
        </p>
      </div>
    </div>
  </div>

  <div class="col-md-6">
    <div class="card bg-light mt-3">
      <div class="card-body">
        <p class="card-text">
          Excellent team player, who listens to team members, values their opinions and converts these diverse opinions into meaningful action.
        </p>
      </div>
    </div>

    <div class="card bg-warning mt-3">
      <div class="card-body">
        <p class="card-text">
Excellent relationship builder with proven interpersonal skills.        </p>
      </div>
    </div>

    <div class="card bg-info mt-3">
      <div class="card-body">
        <p class="card-text">
          Possesses good verbal and written communication skills and fluent in English.
        </p>
      </div>
    </div>
  </div>


</div>